import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const compactPadding = (vertical: string, horizontal: string) =>
  `calc(${vertical} * var(--app-vertical-density)) ${horizontal}`;

const tableCell = {
  padding: compactPadding('0.75rem', '1rem'),
  sm: { padding: compactPadding('0.375rem', '0.5rem') },
  lg: { padding: compactPadding('1rem', '1.25rem') }
};

export const appTheme = {
  preset: definePreset(Aura, {
    semantic: {
      formField: {
        paddingY: 'calc(0.4rem * var(--app-vertical-density))',
        sm: { paddingY: 'calc(0.375rem * var(--app-vertical-density))' },
        lg: { paddingY: 'calc(0.625rem * var(--app-vertical-density))' }
      },
      list: {
        option: { padding: compactPadding('0.5rem', '0.75rem') },
        optionGroup: { padding: compactPadding('0.5rem', '0.75rem') }
      },
      navigation: {
        item: { padding: compactPadding('0.5rem', '0.75rem') }
      }
    },
    components: {
      toggleswitch: {
        root: {
          focusRing: { color: 'var(--color-azul-400)' }
        },
        colorScheme: {
          light: {
            root: {
              background: 'var(--color-neutro-200)',
              hoverBackground: 'var(--color-neutro-200)',
              checkedBackground: 'var(--color-azul-400)',
              checkedHoverBackground: 'var(--color-azul-400)'
            },
            handle: {
              checkedColor: 'var(--color-azul-400)',
              checkedHoverColor: 'var(--color-azul-400)'
            }
          }
        }
      },
      datatable: {
        header: tableCell,
        headerCell: tableCell,
        bodyCell: tableCell,
        footerCell: tableCell,
        footer: tableCell
      }
    }
  }),
  options: {
    darkModeSelector: 'none',
    cssLayer: {
      name: 'primeng',
      order: 'theme, base, primeng'
    }
  }
};
